// extracted by mini-css-extract-plugin
export default {"min_width_form":"webhookConfigure_min_width_form__PwaZX"};